import { memo, useEffect } from 'react';

import { IPdfPageProps } from 'PDF/types/pdf';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessPlanChapters } from 'store/useBusinessToolStore/selectors';

import { useExamplePreview } from 'hooks/useExamplePreview';

import { getListOfActions, getListOfRisks, getMagazineItems } from './mapping';

export const LegalFrameworkAndRisks = memo(({ saveSectionProps, sectionPicture }: IPdfPageProps) => {
  const businessPlanChapters = useBusinessToolStore(getBusinessPlanChapters);
  const { isExamplePage } = useExamplePreview();

  const magazineItems = getMagazineItems(businessPlanChapters);
  const listOfActions = getListOfActions(businessPlanChapters);
  const listOfRisks = getListOfRisks(businessPlanChapters, isExamplePage);

  useEffect(() => {
    if (sectionPicture) {
      const data = {
        listOfActions,
        listOfRisks,
      };

      saveSectionProps('legalFrameworkAndRisks', {
        magazineItems,
        data,
      });
    }
  }, [sectionPicture]);

  return null;
});
